import Pagination from './pagination';
import './styles/index.scss';
export default Pagination;
